import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAxios } from "src/helpers/index";

/** API call to fetch search result based on ItemNumber----------------------------------------------------- **/
export const getSearchResultData = createAsyncThunk(
  "search/getSearchResultData",
  async (model, thunkAPi) => {
    try {
      if (!!(model?.ItemNumber.trimStart())) {
        let res = await getAxios().get(`Search?item=${encodeURIComponent(model?.ItemNumber.trimStart())}`);
        return res?.data;
      } else {
        return []
      }
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** Filter the resule based on selected ItemNumber----------------------------------------------------- **/
export const getSearchSelectResultData = createAsyncThunk(
  "search/getSearchSelectResultData",
  async (model, thunkAPi) => {
    try {
      return model?.id;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** When user search any ItemNumber and click enter then save all respective search results in redux---------------------------------------------------- **/
export const getAllSearchResultData = createAsyncThunk(
  "search/getAllSearchResultData",
  async (model, thunkAPi) => {
    try {
      return model;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

